import './style.scss';
import { Backdrop, Box, Grid, IconButton, Typography } from "@mui/material";
import { useLanguageContext } from '../../../../../contexts/LanguageContext';
import DefaultConstants from '../../../../../data/Constants';
import { useParams } from 'react-router-dom';
import NotFound from '../../../../../components/NotFound';
import Slider from '../../../../../components/Slider';
import DocumentHelper from '../../../../../helpers/DocumentHelper';
import { useState } from 'react';
import { Close } from '@mui/icons-material';

const ServiceDetails = (props) => {
    const { translate, currentLanguage } = useLanguageContext();
    const params = useParams();

    const [backdropOpen, setBackdropOpen] = useState(false);
    const [slideIndex, setSlideIndex] = useState(0);
    
    const service = DefaultConstants.services.items.find(x => x.id === params.id);

    if (service === undefined) {
        return <NotFound text={translate('serviceNotFound')}/>;
    }

    DocumentHelper.setDocumentTitle(translate(service.name));

    return <>
        <Grid container id='servicedetails-section'>
            <Grid item xs={12} className='grid-content-section padding-none'>
                <Box className='wallpaper small' sx={{ backgroundImage: `url(${DefaultConstants.services.wallpaper})` }}>
                    <Typography className='wallpaper-title'>
                        {translate(service.name)}
                    </Typography>

                    <Typography className='wallpaper-subtitle'>
                        {translate(DefaultConstants.services.title)}
                    </Typography>
                </Box>
            </Grid>

            <Grid item md={4} xs={12} className='grid-content-section'>
                <img 
                    src={service.wallpaper} 
                    alt={`${service.name}-wallpaper`} 
                    className='service-wallpaper' 
                    onClick={() => {
                        setBackdropOpen(true);
                        setSlideIndex(0);
                    }}
                />
            </Grid>

            <Grid item md={8} xs={12} className='grid-content-section'>
                <Typography className='service-description'>
                    {translate(service.description)}
                </Typography>
            </Grid>

            <Grid item xs={12} className='grid-content-section backgroundcolor-grey'>
                <Slider
                    arrows={true}
                    slidesPerView={4}
                    interval={0}
                    items={service.images[currentLanguage.value].map((item, index) => {
                        return <img 
                            src={item} 
                            alt={`${service.name}-${index}`} 
                            key={index} 
                            className='service-image' 
                            onClick={() => {
                                setBackdropOpen(true);
                                setSlideIndex(index);
                            }}
                        />;
                    })}
                />
            </Grid>
        </Grid>

        <Backdrop open={backdropOpen} className='backdrop-service-container'>
            <Box className='box-close'>
                <IconButton onClick={() => setBackdropOpen(false)}>
                    <Close fontSize='large' />
                </IconButton>
            </Box>

            <Box className='box-slider'>
                <Slider
                    arrows={true}
                    dots={true}
                    slideInitial={slideIndex}
                    slidesPerView={1}
                    interval={0}
                    items={service.images[currentLanguage.value].map((item, index) => {
                        return <img src={item} alt={`${service.name}-${index}`} key={index} className='backdrop-service-image' />;
                    })}
                />
            </Box>
        </Backdrop>
    </>;
}


export default ServiceDetails;